import React from 'react';

const TickThinIcon = () => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="490"
    height="490"
    viewBox="0 0 24 24">
    <path fill="#3FB0E8" fillRule="evenodd" d="M23.664 4.741l.106.102.06.076c.28.346.213.943-.189 1.272L7.616 19.28c-.332.271-.822.294-1.186.055-.158-.097-.242-.17-.314-.259L.213 11.791l-.082-.113c-.217-.33-.164-.836.154-1.152l.11-.1c.38-.306 1.024-.24 1.362.178l5.344 6.595L22.378 4.72c.335-.273.824-.29 1.18-.059l.106.081z"/>
  </svg>
);

export default TickThinIcon;
